// extracted by mini-css-extract-plugin
export var root = "QYrC";
export var rootButton = "zG3N";
export var rootButtonSecondary = "i0fX";
export var rootButtons = "Ac5+";
export var rootContainer = "urCj";
export var rootCopy = "GPQV";
export var rootDescription = "_2ncx";
export var rootHeading = "KTp3";
export var rootMedia = "hdCA";
export var rootRating = "R1hd";
export var rootRatingCount = "cCky";
export var rootRatingStars = "ci5X";
export var rootRatingValue = "dyf5";